import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { EXHIBIT_TYPE as EXHIBITTYPE } from "./../../../../../../utils/constant.utils";
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import { wirelineTerminateCircuitActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate-circuit.reducer";
import { wirelineTerminateExhibitBActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate/wireline-terminate-exhibit-b.reducer";
import WirelineTerminateExhibitA from "./wireline-terminate-exhibit-a.component";
import WirelineTerminateExhibitB from "./wireline-terminate-exhibit-b.component";

class WirelineTerminateForm extends Component {

    constructor(props) {
        super(props);
    }

    async componentDidMount() {

        await this.props.getExhibitType();
    }

    componentWillUnmount() {
        const { resetWirelineTerminateCircuitForm, resetWirelineTerminateExhibitBForm} = this.props;
        const { exhibitType } = this.props.createRequest;

        if (exhibitType == EXHIBITTYPE.exhibitA) {
            resetWirelineTerminateCircuitForm();
        } else if (exhibitType == EXHIBITTYPE.exhibitB) {
            resetWirelineTerminateExhibitBForm()
        } else {
            //form = null;
        }

        this.props.resetRequestData();
    }

    displayForm = () => {

        const { modalMessage, modalClose} = this.props;
        const { exhibitType } = this.props.createRequest;
        let form;

        if (exhibitType == EXHIBITTYPE.exhibitA) {
            form = <WirelineTerminateExhibitA modalMessage={modalMessage} modalClose={modalClose} hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} />
        } else if (exhibitType == EXHIBITTYPE.exhibitB) {
            form = <WirelineTerminateExhibitB modalMessage={modalMessage} modalClose={modalClose} />
        } else {
            form = null;
        }

        return (form);
    }

    render() {
        return (
            <div>
                {this.displayForm()}
            </div>
        );
    }
};
export default connect(
    state => {
        const { createRequest } = state;
        return {
            createRequest
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, createRequestActions
                , wirelineTerminateCircuitActions
                , wirelineTerminateExhibitBActions),
            dispatch
        )
)(WirelineTerminateForm);